import './styles.css';

export const Card = (props:any)=>{
    return (
        <div className="card-container col-4">
            {props.children}
        </div>
    )
}